import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white p-6 border-t border-gray-200">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">About</h3>
            <p className="text-sm text-gray-600">
              Full-stack developer crafting elegant solutions and digital experiences.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Quick Links</h3>
            <ul className="text-sm text-gray-600 space-y-2">
              <li><a href="#portfolio" className="hover:text-purple-600 transition">Portfolio</a></li>
              <li><a href="#blog" className="hover:text-purple-600 transition">Blog</a></li>
              <li><a href="#contact" className="hover:text-purple-600 transition">Contact</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-gray-800 mb-4">Connect</h3>
            <ul className="text-sm text-gray-600 space-y-2">
              <li><a href="#" className="hover:text-purple-600 transition">LinkedIn</a></li>
              <li><a href="#" className="hover:text-purple-600 transition">GitHub</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6">
          <p className="text-sm text-gray-500 text-center">
            © {currentYear} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
